import React from 'react';
import PropTypes from 'prop-types';
import { Menu as SemanticUIMenu, Segment, Button, Icon } from 'semantic-ui-react';

import Links from './components/Links';
import Logo from './components/Logo';
import Menu from './components/Menu';
import { ChildrenPropType } from '../../../services/proptypes';
import { isMobile } from '../../../services/browser';
import { findComponentsByType } from '../../../services/components';
import Toggleable from '../../../darkmatter/Toggleable';
import {
  LinksDisplayName,
  LogoDisplayName,
  MenuDisplayName,
  ItemDisplayName,
} from './SiteNavigation.constants';
import { mergeLinks } from './SiteNavigation.utils';
import './SiteNavigation.css';

const propTypes = {
  fixed: PropTypes.bool,
  bordered: PropTypes.bool,
  children: ChildrenPropType,
  widths: PropTypes.string,
  hamburgerButtonPosition: PropTypes.oneOf(['left', 'right']),
};

const defaultProps = {
  fixed: false,
  bordered: false,
  children: null,
  widths: null,
  hamburgerButtonPosition: 'left',
};

function SiteNavigation(props) {
  const { fixed, bordered, children, widths, hamburgerButtonPosition } = props;

  if (isMobile()) {
    const logoChildren = findComponentsByType(children, 'Logo');
    const logoChild = logoChildren.length > 0 ? logoChildren[0] : null;
    const menuItems = mergeLinks(findComponentsByType(children, 'Links'));

    return (
      <Segment className="navigation-container">
        <Toggleable>
          {(toggle, onToggle) => (
            <React.Fragment>
              <div className="mobile-nav-header">
                <Button onClick={onToggle} style={{ float: hamburgerButtonPosition }}>
                  <Icon
                    name="bars"
                    size="large"
                    style={{ margin: '0 auto', height: 'unset' }}
                  />
                </Button>
                {logoChild}
              </div>
              {toggle && (
                <SemanticUIMenu
                  secondary
                  stackable
                  vertical
                  fluid
                  borderless={!bordered}
                  size="large"
                  fixed={fixed ? 'top' : null}
                  className="mobile-nav-menu"
                >
                  {menuItems}
                </SemanticUIMenu>
              )}
            </React.Fragment>
          )}
        </Toggleable>
      </Segment>
    );
  }

  return (
    <SemanticUIMenu
      secondary
      stackable
      borderless={!bordered}
      size="large"
      fixed={fixed ? 'top' : null}
      widths={widths}
      className="navigation-container"
    >
      {children}
    </SemanticUIMenu>
  );
}

SiteNavigation.propTypes = propTypes;
SiteNavigation.defaultProps = defaultProps;

export default SiteNavigation;

SiteNavigation.Links = Links;
SiteNavigation.Links.displayName = LinksDisplayName;
SiteNavigation.Logo = Logo;
SiteNavigation.Logo.displayName = LogoDisplayName;
SiteNavigation.Menu = Menu;
SiteNavigation.Menu.displayName = MenuDisplayName;
SiteNavigation.Item = SemanticUIMenu.Item;
SiteNavigation.Item.displayName = ItemDisplayName;
